const getFile = (e: React.ChangeEvent<HTMLInputElement>) => {
  if (e.target.files) return e.target.files[0]
}

export const inputFileProps = {
  getValueFromEvent: getFile,
  valuePropName: '',
}
